// All page tracking data in one maintainable place.
// ===================================================
export const TRACKING_PAGE_DATA_HOME = {
  page: 'talent-homepage',
  siteSection: 'shopfront',
  eventName: 'shopfront_displayed',
};

export const TRACKING_PAGE_DATA_REGISTRATION_COMPLETE = {
  page: 'registration-complete',
  siteSection: 'home',
  subSection: 'confirmation',
};

export const TRACKING_PAGE_DATA_ADDITIONAL_ADVERTISER_REGISTRATION_COMPLETE = {
  page: 'registration-additional-confirmation',
  siteSection: 'account',
};
